import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b0{gap:0.5rem;}.ssr-plugin'
import '.b6{cursor:pointer;}.ssr-plugin'
import '.in{padding:0.75rem;}.ssr-plugin'
import '.ai{border-radius:1.25rem;}.ssr-plugin'
import '.b1{border:var(--blue-border);}.ssr-plugin'
import '.aj{background-color:var(--shades-white);}.ssr-plugin'
import '.e5{transition:background-color 0.2s ease;}.ssr-plugin'
import '.eo{width:2.5rem;}.ssr-plugin'
import '.ep{height:2.5rem;}.ssr-plugin'
import '.io{color:var(--shades-blue-700);}.ssr-plugin'
import '.ip{font-size:0.9rem;}.ssr-plugin'
import '.ar{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a b e f b0 b6 in ai b1 aj e5"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="eo ep a f b io"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="ip io ar"
        >
          {label}
        </span>
      </styled.button>
    )
}